import { Box, makeStyles } from '@material-ui/core';
import { AccountCircleOutlined } from '@material-ui/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { ReactComponent as Bell } from '../../assets/svg/BellSimple.svg';
import { ReactComponent as AmiraIconActive } from '../../assets/svg/amira_icon_active.svg';
import { ReactComponent as AmiraIconInActive } from '../../assets/svg/amira_icon_inactive.svg';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import { ReactComponent as HouseInActive } from '../../assets/svg/house_inactive.svg';
import { colorPrimary } from 'constants/themes';
import { useAppDispatch } from 'redux/store';
import { globalActions } from 'redux/global/global.slice';
const useStyles = makeStyles((theme) => ({
    navigation: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        left: 0,
        maxWidth: 1024,
        right: 0,
        background: colorPrimary,
        padding: '0 32px',
        margin: 'auto',
        height: '56px',
        minHeight: 56,
        borderTop: '1px solid rgb(204 204 204 / 20%)',
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
    },
    navItem: {
        cursor: 'pointer',
    },
    notifyBag: {
        position: 'absolute',
        backgroundColor: 'red',
        fontSize: '9px',
        borderRadius: '50%',
        top: '0px',
        right: '-1px',
        height: 14,
        width: 14,
        minWidth: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    animationBag: {
        animation: `$myEffect 1000ms ${theme.transitions.easing.easeInOut}`,
    },

    '@keyframes myEffect': {
        '0%': {
            height: 14,
            width: 14,
        },
        '50%': {
            height: 18.5,
            width: 18.5,
        },
        '100%': {
            height: 14,
            width: 14,
        },
    },
    iconBag: {
        color: 'white',
        width: 24,
        height: 24,
        position: 'absolute',
        bottom: 3,
        left: 1,
    },
    amiraIconShadow: {
        boxShadow: '0px 0px 12px #F2D4BD',
        borderRadius: '16px',
    },
    animationTotal: {
        animation: `$iconEffect 1000ms ${theme.transitions.easing.easeInOut}`,
    },
    '@keyframes iconEffect': {
        '0%': {
            height: 24,
            width: 24,
        },
        '50%': {
            width: 30,
            height: 30,
            bottom: '0px',
            left: '0px',
        },
        '100%': {
            height: 24,
            width: 24,
        },
    },
}));

function NavigationAnonymous(props) {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const openAuthPopup = () => {
        dispatch(globalActions.setShowAuthPopup(true));
    };
    return (
        <>
            <Box id="bottom-nav" className={classes.navigation} px={3}>
                <Box display={'flex'} height={56} alignItems={'center'} justifyContent={'space-between'}>
                    <div>
                        <span className={classes.navItem} onClick={openAuthPopup}>
                            <HouseInActive style={{ color: 'white' }} />
                        </span>
                    </div>
                    <div>
                        <span className={classes.navItem} onClick={openAuthPopup}>
                            <Bell style={{ color: 'white' }} />
                        </span>
                    </div>
                    <div style={{ marginBottom: 2 }}>
                        <span
                            className={classes.navItem}
                            onClick={() => {
                                history.push(PATH.STYLE_ASSISTANT);
                            }}
                        >
                            {location.pathname === PATH.STYLE_ASSISTANT ? (
                                <AmiraIconActive width={85} style={{ width: 85, height: 90 }} />
                            ) : (
                                <AmiraIconInActive width={50} style={{ width: 50, height: 50 }} />
                            )}
                        </span>
                    </div>
                    <div>
                        <span className={classes.navItem} onClick={openAuthPopup}>
                            <FavoriteBorderOutlinedIcon style={{ color: 'white' }} />
                        </span>
                    </div>
                    <div>
                        <span className={classes.navItem} onClick={openAuthPopup}>
                            <span style={{ color: 'white', position: 'relative' }}>
                                <AccountCircleOutlined />
                            </span>
                        </span>
                    </div>
                </Box>
            </Box>
        </>
    );
}

export default NavigationAnonymous;
